import React from 'react';
import WhiteContainer from '../../../../shared/white-container';
import CustomPieChart from '../../../../shared/pie-chart/custom-piechart';


interface IPieChartOperaDetails {
    stats: any;
    totalSessions?: number;
}

let chartData = [
    { name: 'Match', dbName: 'match', value: 0 },
    { name: 'Discrepancy', dbName: 'discrepancies', value: 0 },
]

const PieChartOperaDetails = ({
    stats,
    totalSessions
}: IPieChartOperaDetails) => {

    chartData = chartData?.map((data) => {
        return {
            ...data,
            value: stats?.[data?.dbName] || 0
        }
    })

    return (
        <WhiteContainer type='rounded'>
            <div>
                <div className='flex flex-row justify-start'>
                    <p className='pl-2 font-bold mb-2'>Opera & Adyen Reconciliation</p>
                </div>
                <CustomPieChart
                    chartData={chartData}
                    totalSessions={totalSessions}
                />
            </div>
        </WhiteContainer>
    )
}

export default PieChartOperaDetails;